'use strict'

module.exports =
  parseEscapedString: (escapedJSONString) ->
    try
      return JSON.parse decodeURIComponent escapedJSONString
    catch
